import { render } from "./BoxshadowPage.vue?vue&type=template&id=e1b58c3c"
import script from "./BoxshadowPage.vue?vue&type=script&lang=js"
export * from "./BoxshadowPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__